<script>
	import { page } from '$app/state';
	import { getContext, onDestroy, onMount } from 'svelte';
	import HeaderBanner from './HeaderBanner.svelte';
	import HeaderLogo from './HeaderLogo.svelte';
	import HeaderMenu from './HeaderMenu.svelte';

	let userData = getContext('userData');
	let signedIn = $derived(userData.signedIn);
	let signingIn = $derived(page.url.pathname.startsWith('/signin'));

	let header = $state(null);
	let resizeObserver = $state(null);

	let showBanner = $derived(
		(page.data.showBanner ?? true) && !signedIn && !signingIn,
	);

	function updateHeaderHeight() {
		document.documentElement.style.setProperty(
			'--header-height',
			header.offsetHeight + 'px',
		);
	}

	onMount(() => {
		updateHeaderHeight();
		if (header && window.ResizeObserver) {
			resizeObserver = new ResizeObserver(updateHeaderHeight);
			resizeObserver.observe(header);
		}
	});

	onDestroy(() => {
		if (resizeObserver) {
			resizeObserver.disconnect();
		}
	});
</script>

<svelte:window onresize={updateHeaderHeight} />

<header
	bind:this={header}
	class="
   fixed top-0 left-0 z-50 w-full shadow-md
   md:relative
 "
	id="header"
	style="view-transition-name: header;"
>
	<HeaderBanner {showBanner} />

	<div
		class="
    full-width bg-indow-blue shadow-md
    md:bg-white
  "
	>
		<ul class="flex list-none items-center">
			<li
				class="
      relative flex items-center
      md:grow
    "
			>
				<HeaderLogo />
			</li>
			<li class="h-full grow">
				<HeaderMenu />
			</li>
		</ul>
	</div>
</header>
